var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"DeviceHistoryGrid"},[_c('v-table',{attrs:{"title":"","headers":_vm.headers,"itemSlots":_vm.slots,"items":_vm.locations,"perPage":_vm.perPage,"page":_vm.page,"total":_vm.total,"loading":false,"onOptionsChange":_vm.handleTableChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }